import { get, post } from '@_shared/config';

import { authModel } from '../index';

export function login(type: authModel.TLoginOAuth, code: string) {
	// localstorage 환경에서 kakao 로그인 테스트를 위해, local일 때 localhost 추가
	if (import.meta.env.VITE_DEVELOP_MODE === 'local') {
		return get<authModel.ILoginResponse>(`/user/${type}/callback/?code=${code}&localhost=True`);
	}

	// 정상적인 서비스 로그인 시도
	return get<authModel.ILoginResponse>(`/user/${type}/callback/?code=${code}`);
}

export function signin(props: authModel.TSignupRequest) {
	return post<authModel.TSignupResponse>('/user/sign-in', props);
}

export function getUserUUID() {
	return get<{ uuid: string }>('/infra/uuid');
}
